__turbopack_context__.v({
  "questionnaireItem": "DocumentsUploadDialog-module__uZ3bwa__questionnaireItem",
});
